export default {
  dashboard: '运营看板',
  csWorkbench: '客服工作台',
  routeWorkbench: '航线工作台',
  productOrderRecords: '产品委托记录',
  businessOrders: '业务委托记录',
  businessOrderManage: '业务委托管理',
  businessOrderDetail: '业务委托详情',
  agreement: '协议管理',
  agreementOrders: '协议委托号',
  customers: '客户管理',
  accountLock: '账户锁定管理',
  basicData: '基础数据',
  system: {
    title: '系统管理',
    users: '用户管理',
    dictionary: '字典管理',
    role: '角色管理',
    permission: '权限管理',
    organization: '组织机构管理',
    config: '系统配置',
    currency: '币种与汇率',
    palletType: '板型管理',
    mawbPool: '主单号池',
    loginLog: '登录日志',
  },
}
